// import React from 'react'
import React, { useState } from "react";
// import "../../assets/scss/wallet-customer/theme/default.scss"
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { setTheme } from "../../redux/actions/themeAction";
import val from "../../getThemeDetails";
import { useEffect } from "react";

// const ThemeSwitcher = () => {
// const [theme,setTheme] = useState('themeBackground');
// const toggleT = () =>{
//     if(theme === "lightThemeBackground"){
//         setTheme('themeBackground')
//     }
//     else{
//         setTheme('lightThemeBackground')
//     }
// }
// useEffect(() =>{
// document.body.className = theme
// },[theme])
//     // const [isDarkMode, setIsDarkMode] = useState(() => {
//     //     const savedTheme = localStorage.getItem('theme');
//     //     return savedTheme === 'dark';
//     // });
//     // useEffect(() => {
//     //     localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
//     // }, [isDarkMode]);
//     // const toggleTheme = () => {
//     //     setIsDarkMode((prevMode) => !prevMode);

//     // };
//     return (
//         // <div className={isDarkMode ? 'themeBackground' : 'lightThemeBackground'}>
//             <label className="switch">
//                 <input type="checkbox" onChange={toggleT} />
//                 <span className="slider"></span>
//             </label>

//         // </div>
//     )
// }
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));
// const MaterialUISwitch = styled((props) => (
//   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
// ))(({ theme }) => ({
//   width: 42,
//   height: 26,
//   padding: 0,
//   '& .MuiSwitch-switchBase': {
//     padding: 0,
//     margin: 2,
//     transitionDuration: '300ms',
//     '&.Mui-checked': {
//       transform: 'translateX(16px)',
//       color: '#fff',
//       '& + .MuiSwitch-track': {
//         backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
//         opacity: 1,
//         border: 0,
//       },
//       '&.Mui-disabled + .MuiSwitch-track': {
//         opacity: 0.5,
//       },
//     },
//     '&.Mui-focusVisible .MuiSwitch-thumb': {
//       color: '#33cf4d',
//       border: '6px solid #fff',
//     },
//     '&.Mui-disabled .MuiSwitch-thumb': {
//       color:
//         theme.palette.mode === 'light'
//           ? theme.palette.grey[100]
//           : theme.palette.grey[600],
//     },
//     '&.Mui-disabled + .MuiSwitch-track': {
//       opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
//     },
//   },
//   '& .MuiSwitch-thumb': {
//     boxSizing: 'border-box',
//     width: 22,
//     height: 22,
//   },
//   '& .MuiSwitch-track': {
//     borderRadius: 26 / 2,
//     backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
//     opacity: 1,
//     transition: theme.transitions.create(['background-color'], {
//       duration: 500,
//     }),
//   },
// }));

// const ThemeSwitcher = () => {
//   // const [theme, setTheme] = useState("themeBackground");
//   // const toggleT = () => {
//   //   if (theme === "lightThemeBackground") {
//   //     setTheme("themeBackground");
//   //   } else {
//   //     setTheme("lightThemeBackground");
//   //   }
//   // };
//   // useEffect(() => {
//   //   document.body.className = theme;
//   // }, [theme]);

//   // return <MaterialUISwitch onChange={toggleT} />;
//   const getInitialTheme = () => {
//     return localStorage.getItem('theme') || 'themeBackground';
//   };

//   // State to store the theme
//   const [theme, setTheme] = useState(getInitialTheme);

//   // Toggle theme and update state
//   const toggleT = () => {
//     const newTheme = theme === 'lightThemeBackground' ? 'themeBackground' : 'lightThemeBackground';
//     setTheme(newTheme);
//   };

//   // Store theme in localStorage and update body class on theme change
//   useEffect(() => {
//     localStorage.setItem('theme', theme);
//     document.body.className = theme;
//   }, [theme]);

//   return <MaterialUISwitch onChange={toggleT} checked={theme === 'lightThemeBackground'} />;
// };
const ThemeSwitcher = () => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.theme.theme);

  // Toggle theme and update Redux state
  // const toggleTheme = () => {
  //   const newTheme = currentTheme ===  "dreamzwalletDark" ? "dreamzwallet" : "dreamzwalletDark";
  //   dispatch(setTheme(newTheme)); // Dispatch the action to update the theme

  // };

  // const toggleTheme = () => {
  //   const newTheme = currentTheme === "dreamzwalletDark" || currentTheme === "defaultDark" || currentTheme === "transactWorldUKDark"
  //     ? (currentTheme === "dreamzwalletDark" ? "dreamzwallet" : currentTheme === "transactWorldUKDark" ? "transactWorldUK" : "default")
  //     : (currentTheme === "dreamzwallet" ? "dreamzwalletDark" : currentTheme === "transactWorldUK" ? "transactWorldUKDark" : "defaultDark");

  //   dispatch(setTheme(newTheme));
  // }

   const toggleTheme = () => {
    const newTheme = currentTheme === "dreamzwalletDark" || currentTheme === "defaultDark" || currentTheme === "transactWorldUKDark" || currentTheme === "onetapDark" || currentTheme === "cunipayDark" || currentTheme === "unipayDark"
      ? (currentTheme === "dreamzwalletDark" ? "dreamzwallet" : currentTheme === "transactWorldUKDark" ? "transactWorldUK" : currentTheme === "onetapDark" ? "onetap" : currentTheme === "cunipayDark" ? "cunipay" : currentTheme === "unipayDark" ? "unipay" : "default")
      : (currentTheme === "dreamzwallet" ? "dreamzwalletDark" : currentTheme === "transactWorldUK" ? "transactWorldUKDark" : currentTheme === "onetap" ? "onetapDark" : currentTheme === "cunipay" ? "cunipayDark" : currentTheme === "unipay" ? "unipayDark" : "defaultDark");

    dispatch(setTheme(newTheme));
  }

  useEffect(() => {
    document.body.classList.remove("themeBackgroundDW", "lightThemeBackgroundDW", "themeBackground", "lightThemeBackground");

    // Add the correct class based on currentTheme
    switch (currentTheme) {
      case "dreamzwallet":
        document.body.classList.add("themeBackgroundDW");
        break;
      case "dreamzwalletDark":
        document.body.classList.add("lightThemeBackgroundDW");
        break;
      case "default":
        document.body.classList.add("themeBackground");
        break;
      case "defaultDark":
        document.body.classList.add("lightThemeBackground");
        break;
      case "unipay":
        document.body.classList.add("themeBackground");
        break;
      case "unipayDark":
        document.body.classList.add("lightThemeBackground");
        break;
      case "aunipay":
        document.body.classList.add("themeBackground");
        break;
      case "aunipayDark":
        document.body.classList.add("lightThemeBackground");
        break;
      case "transactWorldUK":
        document.body.classList.add("themeBackground");
        break;
      case "transactWorldUKDark":
        document.body.classList.add("lightThemeBackground");
        break;
      default:
        document.body.classList.add("themeBackground");
    }

  }, [currentTheme]);

  return (
    <MaterialUISwitch
      checked={currentTheme === val.theme + "Dark"}
      onChange={toggleTheme}
    />
  );
};


export default ThemeSwitcher;
